import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const hamburger = (theme: Theme) => css`
  background: transparent;
  border: none;
  padding: 0;
  outline: none;
  width: ${size[20]};
  height: ${size[12]};
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${theme.palette.text.title};
    border-radius: ${size[4]};
    opacity: 1;
    left: 0;
    transition: 0.25s ease-in-out;
    transform-origin: left center;
  }
  & span:nth-child(1) {
    top: 0px;
  }
  & span:nth-child(2) {
    top: 5px;
  }
  & span:nth-child(3) {
    top: 10px;
  }
`

export const hamburgerOpened = css`
  span:nth-child(1) {
    transform: rotate(45deg);
    top: -1px;
    left: 2px;
  }
  span:nth-child(2) {
    width: 0%;
    opacity: 0;
  }
  span:nth-child(3) {
    transform: rotate(-45deg);
    top: 13px;
    left: 2px;
  }
`

export const inverted = (theme: Theme) => css`
  span {
    background: ${theme.palette.background.main};
  }
`
